import { Box, Grid } from "@mui/material";
import AccordianContainer from "../../../CustomComponents/AccordianContainer";
import CustomTextField from "../../../CustomComponents/CustomTextField";
import { convertDateWithValidation } from "../../helper/losDataHelper";

const ApplicationInfo = ({ applicationInformation }) => {
    return(<>
        <AccordianContainer
         id="accord"
         title="Application Information"
         initialOpen={false}
       >
       <Box sx={{ marginTop: "-1%" }}>
         <Grid container rowSpacing={0} columnSpacing={2}>
         <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
               type="text"
               label="Internal Application ID"
               variant="standard"
               placeholder="Enter Internal Application ID"
               disabled={true}
               value={applicationInformation.internalapplicationid}
             />
             </Grid>
             <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
               type="text"
               label="Lead ID"
               variant="standard"
               placeholder="Enter Lead ID"
               disabled={true}
               value={applicationInformation.leadid}
             />
             </Grid>
             <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
               type="text"
               label="Branch Code"
               variant="standard"
               placeholder="Enter Branch Code"
               disabled={true}
               value={applicationInformation.branchcode}
             />
             </Grid>
             <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
               type="text"
               label="Application Number"
               variant="standard"
               placeholder="Enter Application Number"
               disabled={true}
               value={applicationInformation.applicationnumber}
             />
             </Grid>
             <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
               type="text"
               label="Application Generated Date"
               variant="standard"
               placeholder="Enter Application Generated Date"
               disabled={true}
               value={convertDateWithValidation(applicationInformation.applicationgenerateddate)}
             />
             </Grid>
             <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
               type="text"
               label="Loan Type"
               variant="standard"
               placeholder="Enter Loan Type"
               disabled={true}
               value={applicationInformation.loantype}
             />
             </Grid>
             <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
               type="text"
               label="Institution Name"
               variant="standard"
               placeholder="Enter Institution Name"
               disabled={true}
               value={applicationInformation.institutionname}
             />
             </Grid>
             <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
               type="text"
               label="Loan Amount"
               variant="standard"
               placeholder="Enter Loan Amount"
               disabled={true}
               value={applicationInformation.loanamount}
             />
             </Grid>
             <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
               type="text"
               label="Purpose Of Loan"
               variant="standard"
               placeholder="Enter Purpose Of Loan"
               disabled={true}
               value={applicationInformation.purposeofloan}
             />
             </Grid>
             <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
               type="text"
               label="ROI"
               variant="standard"
               placeholder="Enter ROI"
               disabled={true}
               value={applicationInformation.roi}
             />
             </Grid>
             <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
               type="text"
               label="Tenure"
               variant="standard"
               placeholder="Enter Tenure"
               disabled={true}
               value={applicationInformation.tenure}
             />
             </Grid>
             <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
               type="text"
               label="EMI Amount"
               variant="standard"
               placeholder="Enter EMI Amount"
               disabled={true}
               value={applicationInformation.emiamount}
             />
             </Grid>
             <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
               type="text"
               label="Loan Usage Description"
               variant="standard"
               placeholder="Enter Loan Usage Description"
               disabled={true}
               value={applicationInformation.loanusagedesc}
             />
             </Grid>
             <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
               type="text"
               label="Internal Customer ID"
               variant="standard"
               placeholder="Enter Internal Customer ID"
               disabled={true}
               value={applicationInformation.internalcustomerid}
             />
             </Grid>
             <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
               type="text"
               label="Customer ID"
               variant="standard"
               placeholder="Enter Customer ID"
               disabled={true}
               value={applicationInformation.customerid}
             />
             </Grid>
             <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
               type="text"
               label="Capacity Code"
               variant="standard"
               placeholder="Enter Capacity Code"
               disabled={true}
               value={applicationInformation.capacitycode}
             />
             </Grid>
             <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
               type="text"
               label="Relationship ID"
               variant="standard"
               placeholder="Enter Relationship ID"
               disabled={true}
               value={applicationInformation.relationshipid}
             />
             </Grid>
             <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
               type="text"
               label="Dedupe Check ID"
               variant="standard"
               placeholder="Enter Dedupe Check ID"
               disabled={true}
               value={applicationInformation.dedupecheckid}
             />
             </Grid>
             <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
               type="text"
               label="Is Consent Given"
               variant="standard"
               placeholder="Enter Is Consent Given"
               disabled={true}
               value={applicationInformation.isconsentgiven}
             />
             </Grid>
             <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
               type="text"
               label="Consent Given Date"
               variant="standard"
               placeholder="Enter Consent Given Date"
               disabled={true}
               value={convertDateWithValidation(applicationInformation.consentgivendate)}
             />
             </Grid>
             <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
               type="text"
               label="Consent Document Number"
               variant="standard"
               placeholder="Enter Consent Document Number"
               disabled={true}
               value={applicationInformation.consentdocumentnumber}
             />
             </Grid>
             <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
               type="text"
               label="Is Kyc Done"
               variant="standard"
               placeholder="Enter Is Kyc Done"
               disabled={true}
               value={applicationInformation.iskycdone}
             />
             </Grid>
         <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
               type="text"
               label="Is Applicant Dropped"
               variant="standard"
               placeholder="Enter Is Applicant Dropped"
               disabled={true}
               value={applicationInformation.isapplicantdroped}
             />
             </Grid>
             <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
               type="text"
               label="Is Application Dropped"
               variant="standard"
               placeholder="Enter Is Application Dropped"
               disabled={true}
               value={applicationInformation.isapplicationdroped}
             />
             </Grid>
             <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
               type="text"
               label="Created User"
               variant="standard"
               placeholder="Enter Created User"
               disabled={true}
               value={applicationInformation.createdUser}
             />
             </Grid>
             </Grid>
             </Box>
       </AccordianContainer>
   </>);
}

export default ApplicationInfo;